<template>
  <component
    :is="tag"
    class="row"
    :class="{
      'no-gutters': noGutters,
      [`align-items-${alignV}`]: alignV,
      [`align-content-${alignContent}`]: alignContent,
      [`justify-content-${alignH}`]: alignH
    }"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: 'BRow',
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    alignContent: {
      type: String,
      validator: (value) => {
        return [
          'between',
          'around',
          'stretch'
        ].includes(value)
      },
      default: null
    },
    alignH: {
      type: String,
      validator: (value) => {
        return [
          'between',
          'around',
          'center'
        ].includes(value)
      },
      default: null
    },
    alignV: {
      type: String,
      validator: (value) => {
        return [
          'baseline',
          'stretch'
        ].includes(value)
      },
      default: null
    },
    noGutters: Boolean
  }
}
</script>
